"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANTON_API = exports.STARCK_API = exports.isProdBuild = exports.getBuildEnv = exports.isProd = exports.getEnv = void 0;
const getEndpointPrefix = (addHypen = true) => {
    const hypen = addHypen ? '-' : '';
    let endpointPrefix = `staging${hypen}`;
    if (typeof window !== 'undefined') {
        endpointPrefix =
            !window.location.host.includes('staging') &&
                !window.location.host.includes('testing') &&
                !window.location.host.includes('localhost')
                ? ''
                : window.location.host.includes('testing')
                    ? `testing${hypen}`
                    : `staging${hypen}`;
    }
    return endpointPrefix;
};
exports.getEnv = () => {
    let env = 'testing';
    if (typeof window !== 'undefined') {
        env =
            !window.location.host.includes('staging') &&
                !window.location.host.includes('testing') &&
                !window.location.host.includes('localhost')
                ? 'production'
                : window.location.host.includes('staging')
                    ? 'staging'
                    : window.location.host.includes('localhost')
                        ? 'localhost'
                        : 'testing';
    }
    return env;
};
exports.isProd = () => {
    return exports.getEnv() === 'production';
};
exports.getBuildEnv = () => { var _a; return (_a = process.env.BUILD_ENV) !== null && _a !== void 0 ? _a : 'testing'; };
exports.isProdBuild = () => exports.getBuildEnv() === 'production';
exports.STARCK_API = (() => {
    var _a;
    if (exports.getEnv() === 'localhost') {
        return (_a = process.env.NEXT_PUBLIC_STARCK_API) !== null && _a !== void 0 ? _a : 'https://staging-starck.booninterior.com';
    }
    return `https://${getEndpointPrefix()}starck.booninterior.com`;
})();
exports.PANTON_API = (() => {
    var _a;
    if (exports.getEnv() === 'localhost') {
        return (_a = process.env.NEXT_PUBLIC_PANTON_API) !== null && _a !== void 0 ? _a : 'https://staging-panton.booninterior.com';
    }
    return `https://${getEndpointPrefix()}panton.booninterior.com`;
})();
